export default "__VITE_ASSET__CjKouBR8__"